import {
  OMSMetricsRequestSchema,
  ShipmentsByCarrierResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getShipmentsByCarrier = {
  name: "getShipmentsByCarrier" as const,
  input: OMSMetricsRequestSchema,
  output: ShipmentsByCarrierResponseSchema,
};
